import React from 'react';
import { Card, CardContent } from '@/components/ui/card';
import { Scissors, Crown, Sparkles } from 'lucide-react';

const Services = () => {
  const coiffureHommes = [
    { service: "Coupe simple", prix: "15 €" },
    { service: "Coupe + barbe", prix: "20 €" },
    { service: "Coupe colorant", prix: "25 €" },
    { service: "Décolorant simple", prix: "25 €" },
    { service: "Décolorant + coupe", prix: "30 €" },
    { service: "Contour + barbe", prix: "10 €" },
    { service: "Barbe simple", prix: "5 €" },
    { service: "Application locks", prix: "à partir de 100 €" },
    { service: "Défrisage cheveux crépus", prix: "à partir de 25 €" }
  ];

  const tressesFemmes = [
    { service: "Nattes collées / Cornrows", prix: "40 €" },
    { service: "Box braids / Knotless braids", prix: "60 €" },
    { service: "Jumbo braids", prix: "Prix sur place" },
    { service: "Tresses avec rajouts (Feed-in / Ghana braids)", prix: "Prix sur place" },
    { service: "Fulani / Lemonade braids", prix: "Prix sur place" },
    { service: "Vanilles / Senegalese & Marley twists", prix: "Prix sur place" },
    { service: "Goddess braids / Bohemian braids", prix: "Prix sur place" },
    { service: "Crochet braids / Faux locks / Bantu knots", prix: "Prix sur place" }
  ];

  const ongles = [
    {
      category: "Pose au gel / porcelaine",
      services: [
        { service: "Pose sur ongles naturels", prix: "34 €" },
        { service: "Pose sur capsules", prix: "39 €" },
        { service: "Rallongement d'un ongle", prix: "+1 €" },
        { service: "Dépose", prix: "10 €" }
      ]
    },
    {
      category: "Vernis semi-permanent",
      services: [
        { service: "Pose classique", prix: "25 €" },
        { service: "Pose French", prix: "30 €" },
        { service: "Dépose", prix: "10 €" }
      ]
    },
    {
      category: "Beauté des mains et des pieds",
      services: [
        { service: "Manucure simple", prix: "15 €" },
        { service: "Avec semi-permanent", prix: "+10 €" },
        { service: "Pédicure simple", prix: "30 €" },
        { service: "Pédicure avec semi-permanent", prix: "45 €" },
        { service: "Pédicure homme", prix: "35 €" }
      ]
    },
    {
      category: "Options & décorations",
      services: [
        { service: "French", prix: "+5 €" },
        { service: "Babyboomer", prix: "+5 €" },
        { service: "Chromé", prix: "+2 €" },
        { service: "Strass", prix: "à partir de 0,50 €" },
        { service: "Feuilles d'or", prix: "+3 €" },
        { service: "Motif personnalisé", prix: "sur devis" }
      ]
    }
  ];

  return (
    <div className="pt-16">
      {/* Hero Section */}
      <section className="py-20 bg-gradient-to-b from-background to-secondary/20">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h1 className="heading-xl font-display mb-6">
            Nos <span className="text-gradient">Services</span> et Tarifs
          </h1>
          <p className="text-enhanced max-w-3xl mx-auto mb-8">
            Des prestations professionnelles, des produits de qualité, et un savoir-faire unique pour chaque type de cheveux. 
            <span className="text-primary font-semibold">Chez Pablo Coiffure, la perfection est notre signature.</span>
          </p>
          
          <div className="flex flex-wrap justify-center gap-4 mt-8">
            <div className="flex items-center gap-2 px-4 py-2 bg-primary/10 rounded-full">
              <Scissors className="h-5 w-5 text-primary" />
              <span className="text-primary font-medium">Coiffure Hommes</span>
            </div>
            <div className="flex items-center gap-2 px-4 py-2 bg-gradient-to-r from-pink-500/10 to-purple-500/10 rounded-full">
              <Crown className="h-5 w-5 text-pink-400" />
              <span className="text-pink-400 font-medium">Tresses Femmes</span>
            </div>
            <div className="flex items-center gap-2 px-4 py-2 bg-gradient-to-r from-pink-400/10 to-rose-400/10 rounded-full">
              <Sparkles className="h-5 w-5 text-rose-400" />
              <span className="text-rose-400 font-medium">Ongles</span>
            </div>
          </div>
        </div>
      </section>

      {/* Coiffure Hommes */}
      <section className="py-16 bg-secondary/30">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-12">
            <div className="flex justify-center mb-6">
              <div className="p-4 bg-primary/10 rounded-full">
                <Scissors className="h-12 w-12 text-primary" />
              </div>
            </div>
            <h2 className="text-3xl md:text-4xl font-display font-bold mb-4">
              L'élégance au <span className="text-gradient">masculin</span>
            </h2>
            <p className="text-lg text-muted-foreground max-w-2xl mx-auto">
              Chez Pablo Coiffure, chaque coupe est une œuvre d'art. Que vous recherchiez un look classique, urbain ou moderne, 
              Pablo met son savoir-faire au service de votre style.
            </p>
          </div>

          <Card className="card-luxury max-w-4xl mx-auto">
            <CardContent className="p-8">
              <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                {coiffureHommes.map((item, index) => (
                  <div key={index} className="flex justify-between items-center py-3 border-b border-border/50 last:border-b-0">
                    <span className="text-foreground font-medium">{item.service}</span>
                    <span className="text-primary font-semibold">{item.prix}</span>
                  </div>
                ))}
              </div>
            </CardContent>
          </Card>
        </div>
      </section>

      {/* Tresses Femmes */}
      <section className="py-16 feminine-section">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-12">
            <div className="flex justify-center mb-6">
              <div className="p-4 bg-gradient-to-br from-pink-500/20 to-purple-500/20 rounded-full">
                <Crown className="h-12 w-12 text-pink-400" />
              </div>
            </div>
            <h2 className="heading-lg font-display mb-4">
              L'art des tresses <span className="feminine-accent">féminines</span>
            </h2>
            <p className="text-enhanced max-w-2xl mx-auto">
              Les tresses sont plus qu'une coiffure : elles sont une <span className="feminine-accent font-semibold">signature</span>. 
              Chez Pablo Coiffure, nous allions tradition et modernité pour créer des styles qui subliment chaque femme.
            </p>
          </div>

          <Card className="feminine-card max-w-4xl mx-auto shadow-lg">
            <CardContent className="p-8">
              <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                {tressesFemmes.map((item, index) => (
                  <div key={index} className="flex justify-between items-center py-3 border-b border-border/50 last:border-b-0">
                    <span className="text-foreground font-medium">{item.service}</span>
                    <span className="text-primary font-semibold">{item.prix}</span>
                  </div>
                ))}
              </div>
              <div className="mt-6 p-4 bg-primary/5 rounded-lg">
                <p className="text-sm text-muted-foreground text-center">
                  <strong>Note :</strong> Les tarifs peuvent varier selon la longueur et la complexité de la coiffure. 
                  Devis personnalisé sur place.
                </p>
              </div>
            </CardContent>
          </Card>
        </div>
      </section>

      {/* Ongles */}
      <section className="py-16 feminine-section">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-12">
            <div className="flex justify-center mb-6">
              <div className="p-4 bg-gradient-to-br from-rose-400/20 to-pink-400/20 rounded-full">
                <Sparkles className="h-12 w-12 text-rose-400" />
              </div>
            </div>
            <h2 className="heading-lg font-display mb-4">
              Ongles de <span className="feminine-accent">rêve</span> by Pablo
            </h2>
            <p className="text-enhanced max-w-2xl mx-auto">
              Des mains soignées, des ongles sublimes, un résultat durable. 
              Chez Pablo Coiffure, <span className="feminine-accent font-semibold">la beauté se prolonge jusqu'au bout des doigts</span>.
            </p>
          </div>

          <div className="grid grid-cols-1 lg:grid-cols-2 gap-8">
            {ongles.map((category, categoryIndex) => (
              <Card key={categoryIndex} className="feminine-card hover:shadow-xl transition-all duration-300">
                <CardContent className="p-6">
                  <h3 className="text-xl font-semibold feminine-accent mb-6 text-center">
                    {category.category}
                  </h3>
                  <div className="space-y-4">
                    {category.services.map((item, index) => (
                      <div key={index} className="flex justify-between items-center py-2 border-b border-border/30 last:border-b-0">
                        <span className="text-foreground">{item.service}</span>
                        <span className="text-primary font-semibold">{item.prix}</span>
                      </div>
                    ))}
                  </div>
                </CardContent>
              </Card>
            ))}
          </div>
        </div>
      </section>

      {/* Promotions Section */}
      <section className="py-16 bg-gradient-to-b from-background to-secondary/20">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-12">
            <h2 className="heading-lg font-display mb-4">
              Offres <span className="text-gradient">spéciales</span>
            </h2>
            <p className="text-enhanced max-w-2xl mx-auto">
              Profitez de nos promotions et forfaits avantageux pour encore plus de beauté !
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            <Card className="card-luxury hover:shadow-xl transition-all duration-300 border-2 border-primary/20">
              <CardContent className="p-6 text-center">
                <div className="w-16 h-16 bg-primary/10 rounded-full flex items-center justify-center mx-auto mb-4">
                  <span className="text-2xl font-bold text-primary">-10%</span>
                </div>
                <h3 className="text-xl font-semibold mb-2">Tarif Étudiant</h3>
                <p className="text-muted-foreground mb-4">
                  10% de réduction sur toutes les prestations coiffure sur présentation de la carte étudiante.
                </p>
                <span className="inline-block px-3 py-1 bg-primary/10 text-primary text-sm font-medium rounded-full">
                  Valable toute l'année
                </span>
              </CardContent>
            </Card>

            <Card className="feminine-card hover:shadow-xl transition-all duration-300 border-2 border-pink-400/20">
              <CardContent className="p-6 text-center">
                <div className="w-16 h-16 bg-gradient-to-br from-pink-400/20 to-rose-400/20 rounded-full flex items-center justify-center mx-auto mb-4">
                  <Crown className="h-8 w-8 text-pink-400" />
                </div>
                <h3 className="text-xl font-semibold mb-2">Forfait Beauté Complète</h3>
                <p className="text-muted-foreground mb-4">
                  Tresses + manucure gel : économisez 15€ sur le tarif normal. L'élégance de la tête aux pieds !
                </p>
                <span className="inline-block px-3 py-1 bg-pink-400/10 text-pink-400 text-sm font-medium rounded-full">
                  Économie garantie
                </span>
              </CardContent>
            </Card>

            <Card className="card-luxury hover:shadow-xl transition-all duration-300 border-2 border-primary/20">
              <CardContent className="p-6 text-center">
                <div className="w-16 h-16 bg-primary/10 rounded-full flex items-center justify-center mx-auto mb-4">
                  <Scissors className="h-8 w-8 text-primary" />
                </div>
                <h3 className="text-xl font-semibold mb-2">Forfait Homme Complet</h3>
                <p className="text-muted-foreground mb-4">
                  Coupe + barbe + soin : le forfait idéal pour un look parfait. Tarif préférentiel à 25€ au lieu de 30€.
                </p>
                <span className="inline-block px-3 py-1 bg-primary/10 text-primary text-sm font-medium rounded-full">
                  Populaire
                </span>
              </CardContent>
            </Card>
          </div>

          <div className="text-center mt-12">
            <p className="text-muted-foreground mb-4">
              📱 Suivez-nous sur Instagram <strong>@pablocoiffure</strong> pour ne manquer aucune promotion !
            </p>
            <a 
              href="https://instagram.com/pablocoiffure"
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center justify-center px-6 py-3 border-2 border-primary text-primary hover:bg-primary hover:text-primary-foreground font-semibold rounded-lg transition-all duration-300"
            >
              Suivre sur Instagram
            </a>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-20 bg-gradient-to-r from-primary/10 to-primary-glow/10">
        <div className="max-w-4xl mx-auto text-center px-4 sm:px-6 lg:px-8">
          <h2 className="text-3xl md:text-4xl font-display font-bold mb-6">
            Prêt à réserver votre <span className="text-gradient">prestation</span> ?
          </h2>
          <p className="text-lg text-muted-foreground mb-8">
            Contactez-nous dès maintenant pour prendre rendez-vous et découvrir nos services d'exception.
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <a 
              href="/booking"
              className="inline-flex items-center justify-center px-8 py-3 bg-gradient-to-r from-primary to-primary-glow text-primary-foreground font-semibold rounded-lg hover:shadow-xl hover:shadow-primary/30 transform hover:scale-105 transition-all duration-300"
            >
              Prendre rendez-vous
            </a>
            <a 
              href="https://wa.me/33767632259"
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center justify-center px-8 py-3 border-2 border-primary text-primary hover:bg-primary hover:text-primary-foreground font-semibold rounded-lg transform hover:scale-105 transition-all duration-300"
            >
              WhatsApp
            </a>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Services;